<ion-app>
  <ion-router-outlet [animated]="false" />
</ion-app>
